import { imgUrl } from "@/lib/api";

const Tile = ({ id, name, icon, active, onClick }) => (
  <button
    data-testid={`category-${id}`}
    data-active={active ? "true" : "false"}
    onClick={onClick}
    className={`flex min-w-[84px] shrink-0 flex-col items-center justify-center gap-1.5 rounded-2xl border-2 px-3 py-2.5 text-xs font-extrabold text-white transition-[border-color,box-shadow,background-color] duration-150 ${
      active
        ? "border-[#FFD60A] bg-[#FFD60A]/10 shadow-[0_0_16px_rgba(255,214,10,0.6)]"
        : "border-[#A64DFF]/70 bg-[#120a1f] hover:border-[#A64DFF] hover:shadow-[0_0_14px_rgba(166,77,255,0.55)]"
    }`}
  >
    {icon && <img src={imgUrl(icon)} alt="" className="h-12 w-12 object-contain" data-testid={`category-icon-${id}`} />}
    <span className="whitespace-nowrap">{name}</span>
  </button>
);

const Chip = ({ testId, label, count, active, onClick }) => (
  <button
    data-testid={testId}
    data-active={active ? "true" : "false"}
    onClick={onClick}
    className={`shrink-0 rounded-full border-2 px-3.5 py-1.5 text-xs font-bold transition-[background-color,box-shadow,border-color] duration-150 ${
      active ? "border-[#FFD60A] bg-[#FFD60A] text-[#0b0b0f] shadow-[0_0_12px_rgba(255,214,10,0.6)]" : "border-white/25 text-white hover:border-[#FFD60A]"
    }`}
  >
    {label} <span className="opacity-60">({count})</span>
  </button>
);

const Row = ({ children, testId }) => (
  <div data-testid={testId} className="-mx-3 flex gap-2 overflow-x-auto px-3 pb-1 sm:mx-0 sm:px-0">{children}</div>
);

const slug = (s) => s.replace("/", "-").toLowerCase();

export const CategoryNav = ({ tree, nav, onChange }) => {
  if (!tree.length) return null;
  const cat = tree.find((c) => c.id === nav.cat);
  const lang = cat?.children.find((l) => l.id === nav.lang);
  return (
    <nav data-testid="category-strip" aria-label="Categorie" className="mt-4 space-y-2">
      <Row>
        <Tile id="all" name="Tutte" active={!nav.cat} onClick={() => onChange({})} />
        {tree.map((c) => (
          <Tile key={c.id} id={c.id} name={c.name} icon={c.icon} active={nav.cat === c.id}
            onClick={() => onChange(nav.cat === c.id ? {} : { cat: c.id })} />
        ))}
      </Row>
      {cat && (
        <Row testId="category-langs">
          {cat.children.map((l) => (
            <Chip key={l.id} testId={`nav-lang-${l.id}`} label={l.name} count={l.count} active={nav.lang === l.id}
              onClick={() => onChange(nav.lang === l.id ? { cat: cat.id } : { cat: cat.id, lang: l.id })} />
          ))}
        </Row>
      )}
      {lang && (
        <Row testId="category-types">
          {lang.children.map((t) => (
            <Chip key={t.id} testId={`nav-type-${slug(t.id)}`} label={t.name} count={t.count} active={nav.type === t.id}
              onClick={() => onChange(nav.type === t.id ? { cat: cat.id, lang: lang.id } : { cat: cat.id, lang: lang.id, type: t.id })} />
          ))}
        </Row>
      )}
    </nav>
  );
};

export const navTitle = (tree, nav) => {
  const cat = tree.find((c) => c.id === nav.cat);
  const lang = cat?.children.find((l) => l.id === nav.lang);
  const type = lang?.children.find((t) => t.id === nav.type);
  return (type || lang || cat)?.name;
};
